<template>
  <div class="main-content-container container" style="max-width: 90% !important;">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-6 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">sessão</span>
        <h3 class="page-title">Dados Bancários Inválidos</h3>
      </div>
      <!-- Page Header - Filters -->
      <div class="col-6 d-flex">
        <div class="input-group d-flex justify-content-end my-auto">
          <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
            <i class="fas fa-filter"></i>
            {{ countFilter > 0 ? "Filtros aplicados" : "" }}
            <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
          </button>
          <button v-if="countFilter > 0" type="button" class="input-group-text btn-sm ml-1 mt-3" v-b-tooltip.hover.bottom
            title="Limpar filtros" @click="ResetFilter()">
            <i class="fas fa-eraser"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <div class="float-left">
              <h6 class="m-0">Dados Bancários Inválidos</h6>
            </div>
            <div v-if="pagination.TotalItems > 0" class="float-right">
              <b-input-group class="d-flex justify-content-end my-auto ml-2">
                <h6 v-if="pagination.TotalItems > 0" class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </b-input-group>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <loader :is-loading="loadingList"></loader>
            <table class="table mb-0" v-if="!loadingList">
              <thead class="bg-s2p-gray-light">
                <tr>
                  <th scope="col" class="border-0"></th>
                  <th scope="col" class="border-0 text-left">
                    {{ labelBanco }}
                  </th>
                  <th scope="col" class="border-0">
                    {{ labelTipoConta }}
                  </th>
                  <th scope="col" class="border-0 text-left">
                    {{ labelAgencia }}
                  </th>
                  <th scope="col" class="border-0">{{ labelConta }}</th>
                  <th scope="col" class="border-0">{{ labelDocumento }}</th>
                  <th scope="col" class="border-0">{{ labelNome }}</th>
                  <th scope="col" class="border-0"></th>
                  <th scope="col" class="border-0">{{ labelBancoRecusa }}</th>
                  <th scope="col" class="border-0">{{ labelMotivoRecusa }}</th>
                  <th scope="col" class="border-0">{{ labelDataRecusa }}</th>
                  <th scope="col" class="border-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transferenciaRecusada, index) in transferenciaRecusadaLista" :key="index">
                  <td style="vertical-align: middle;">
                    <img v-if="transferenciaRecusada.CodigoBanco == '001'" src="@/assets/images/bank_0001.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '033'" src="@/assets/images/bank_0033.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '041'" src="@/assets/images/bank_0041.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '104'" src="@/assets/images/bank_0104.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '237'" src="@/assets/images/bank_0237.jpg"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '341'" src="@/assets/images/bank_0341.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '422'" src="@/assets/images/bank_0422.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '745'" src="@/assets/images/bank_0745.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.CodigoBanco == '748'" src="@/assets/images/bank_0748.png"
                      height="32px" width="32px" class="logo" />
                  </td>
                  <td class="text-left" style="vertical-align: middle;">{{ transferenciaRecusada.Banco }}</td>
                  <td style="vertical-align: middle;">{{ transferenciaRecusada.TipoConta }}</td>
                  <td class="text-nowrap" style="vertical-align: middle;">
                    {{
                      transferenciaRecusada.Agencia
                    }}{{ transferenciaRecusada.AgenciaDigito != null ? "-" + transferenciaRecusada.AgenciaDigito : "" }}
                  </td>
                  <td class="text-center text-nowrap" style="vertical-align: middle;">
                    {{
                      transferenciaRecusada.Conta
                    }}{{ transferenciaRecusada.ContaDigito != null ? "-" + transferenciaRecusada.ContaDigito : "" }}
                  </td>
                  <td class="text-nowrap" style="vertical-align: middle;">{{ transferenciaRecusada.Documento | identity }}
                  </td>
                  <td style="vertical-align: middle;">{{ transferenciaRecusada.Nome }}</td>
                  <td style="vertical-align: middle;">
                    <img v-if="transferenciaRecusada.BancoRecusa == 'Banco do Brasil'" src="@/assets/images/bank_0001.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.BancoRecusa == 'Santander'" src="@/assets/images/bank_0033.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.BancoRecusa == 'Banrisul'" src="@/assets/images/bank_0041.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.BancoRecusa == 'Caixa'" src="@/assets/images/bank_0104.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.BancoRecusa == 'Bradesco'" src="@/assets/images/bank_0237.jpg"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.BancoRecusa == 'Safra'" src="@/assets/images/bank_0422.png"
                      height="32px" width="32px" class="logo" />
                    <img v-if="transferenciaRecusada.BancoRecusa == 'Sicredi'" src="@/assets/images/bank_0748.png"
                      height="32px" width="32px" class="logo" />
                  </td>
                  <td style="vertical-align: middle;">{{ transferenciaRecusada.BancoRecusa }}</td>
                  <td style="vertical-align: middle;">{{ transferenciaRecusada.MotivoRecusa }}</td>
                  <td style="vertical-align: middle;">{{ transferenciaRecusada.DataRecusa }}</td>
                  <td style="vertical-align: middle;">
                    <div class="dropdown">
                      <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Opções
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" href="#"
                          v-on:click="AbrirModalRemover($event, transferenciaRecusada.Id)">
                          <i class="fas fa-minus-square mr-2"></i> Remover
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="
                  transferenciaRecusadaLista == undefined ||
                  transferenciaRecusadaLista == null ||
                  transferenciaRecusadaLista.length == 0
                ">
                  <td colspan="6">Sem registros</td>
                </tr>
              </tbody>
            </table>

            <div class="col-12 border-top">
              <div class="pagination-nav">
                <b-pagination class="float-right" v-model="pagination.PageNumber" :total-rows="pagination.TotalItems"
                  :per-page="pagination.RowsPerPage" aria-controls="my-table"></b-pagination>
                <div class="float-left">
                  <d-select size="sm" v-model="pagination.RowsPerPage">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                  </d-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Código do banco</label>
          <input type="text" class="form-control" v-model="filter.Banco" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Agência (sem dígito)</label>
          <input class="form-control" type="text" v-model="filter.Agencia" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Conta (sem dígito)</label>
          <input class="form-control" type="text" v-model="filter.Conta" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>CPF/CNPJ</label>
          <the-mask class="form-control" type="tel" :mask="['##.###.###/####-##', '###.###.###-##']"
            v-model="filter.Documento" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Nome</label>
          <input class="form-control" type="text" v-model="filter.Nome" v-on:keyup.enter="Filter()" />
        </d-col>

        <d-col md="6" class="form-group">
          <label>Motivo da Recusa</label>
          <d-select v-model="filter.MotivoRecusa" :value="null">
            <option :value="null" selected>Selecione</option>
            <option v-for="motivo in motivosRecusa" v-bind:key="motivo.Codigo" v-bind:value="motivo.Codigo">
              {{ motivo.Nome }}
            </option>
          </d-select>
        </d-col>

        <d-col md="6" class="form-group">
          <label>Data Inicial da Recusa</label>
          <date-field v-model="filter.DataInicialRecusa" format="dd MMMM yyyy" minimumView="day"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <label>Data Final da Recusa</label>
          <date-field v-model="filter.DataFinalRecusa" format="dd MMMM yyyy" minimumView="day"
            :minDate="this.filter.DataInicialRecusa"></date-field>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button variant="primary" class="input-group-text" v-b-tooltip.hover.bottom title="Limpar filtros"
          @click="ResetFilter()">
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal size="lg" id="mFormTransferenciaRecusada" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">
          {{ modalTitulo }}
        </h5>
        <button class="close" @click="HideModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingList"></loader>

      <ValidationObserver tag="form" ref="ActionValidationForm">
        <div v-if="!loadingList">
          <d-form-row class="d-flex justify-content-between">
            <d-col md="10" class="form-group">
              <label>{{ labelBanco }}</label>
              <d-form-input type="text" v-model="transferenciaRecusada.Banco" readonly />
            </d-col>

            <d-col md="2" class="form-group">
              <label>{{ labelTipoConta }}</label>
              <d-form-input type="text" v-model="transferenciaRecusada.TipoConta" readonly />
            </d-col>
          </d-form-row>

          <d-form-row class="d-flex justify-content-between">
            <d-col md="3" class="form-group">
              <label>{{ labelAgencia }}</label>
              <d-form-input type="text" v-model="transferenciaRecusada.Agencia" readonly />
            </d-col>

            <d-col md="2" class="form-group">
              <label>{{ labelAgenciaDigito }}</label>
              <d-form-input type="text" v-model="transferenciaRecusada.AgenciaDigito" readonly />
            </d-col>

            <d-col md="5" class="form-group">
              <label>{{ labelConta }}</label>
              <d-form-input type="text" v-model="transferenciaRecusada.Conta" readonly />
            </d-col>

            <d-col md="2" class="form-group">
              <label>{{ labelContaDigito }}</label>
              <d-form-input type="text" v-model="transferenciaRecusada.ContaDigito" readonly />
            </d-col>
          </d-form-row>
          <d-form-row class="d-flex justify-content-between">
            <d-col md="9" class="form-group">
              <label>{{ labelNome }}</label>
              <d-form-input class="form-control" v-model="transferenciaRecusada.Nome" readonly />
            </d-col>

            <d-col md="3" class="form-group">
              <label>{{ labelDocumento }}</label>
              <the-mask class="form-control" type="text" :mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="transferenciaRecusada.Documento" readonly />
            </d-col>
          </d-form-row>
          <d-form-row class="d-flex justify-content-between">
            <d-col md="9" class="form-group">
              <label>{{ labelMotivoRecusa }}</label>
              <d-form-input class="form-control" v-model="transferenciaRecusada.MotivoRecusa" readonly />
            </d-col>

            <d-col md="3" class="form-group">
              <label>{{ labelDataRecusa }}</label>
              <d-form-input class="form-control" v-model="transferenciaRecusada.DataRecusa" readonly />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>{{ labelMotivoRemocao }}</label>
              <ValidationProvider rules="required|min:3|max:100" v-slot="{ errors, invalid }">
                <d-form-input v-model="transferenciaRecusada.MotivoRemocao"
                  :class="validatedActionForm | showValidateError(invalid)" type="text" />
                <div class="invalid-feedback d-block" v-if="validatedActionForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </div>
      </ValidationObserver>

      <template slot="modal-footer">
        <b-button-group>
          <b-button type="button" class="btn btn-success" :disabled="loadingUpdate"
            v-on:click="RemoverTransferenciaRecusada()">
            <template v-if="!loadingUpdate">{{ "Remover" }}</template>
            <template v-else>
              <loader :small="true" :isLoading="loadingUpdate"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "transferencia-recusada",
  components: {
    dateField
  },
  data: function () {
    return {
      transferenciaRecusada: {
        Id: null,
        Banco: null,
        Agencia: null,
        AgenciaDigito: null,
        Conta: null,
        ContaDigito: null,
        Documento: null,
        TipoConta: null,
        Nome: null,
        MotivoRecusa: null,
        DataRecusa: null,
        MotivoRemocao: null
      },

      countFilter: 0,
      filter: {
        Banco: null,
        Agencia: null,
        Conta: null,
        Documento: null,
        Nome: null,
        MotivoRecusa: null,
        DataInicialRecusa: null,
        DataFinalRecusa: null
      },

      modalTitulo: "Remoção de Dados Bancários Inválidos",
      labelBanco: "Banco",
      labelTipoConta: "Tipo de Conta",
      labelAgencia: "Agência",
      labelAgenciaDigito: "Dígito Agência",
      labelConta: "Conta",
      labelContaDigito: "Dígito Conta",
      labelDocumento: "CPF/CNPJ",
      labelNome: "Nome",
      labelBancoRecusa: "Banco da Recusa",
      labelMotivoRecusa: "Motivo da Recusa",
      labelDataRecusa: "Data da Recusa",
      labelMotivoRemocao: "Motivo da Remoção",

      loadingList: false,
      loadingTransferenciaRecusada: false,
      loadingUpdate: false,
      validatedActionForm: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      transferenciaRecusadaLista: [],
      motivosRecusa: []
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.TransferenciaRecusadaListar();
    },
    "pagination.RowsPerPage": function () {
      this.TransferenciaRecusadaListar();
    }
  },
  mounted() {
    this.TransferenciaRecusadaListar();
    this.MotivosRecusaListar();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    HideModal: function () {
      this.$bvModal.hide("mFormTransferenciaRecusada");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.TransferenciaRecusadaListar();
    },
    MotivosRecusaListar: function () {
      this.$store
        .dispatch("MotivosRecusaListar")
        .then(response => {
          this.motivosRecusa = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de motivos de recusa", error);
        });
    },
    TransferenciaRecusadaListar: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Banco)) this.countFilter++;
      if (hasValue(this.filter.Agencia)) this.countFilter++;
      if (hasValue(this.filter.Conta)) this.countFilter++;
      if (hasValue(this.filter.Documento)) this.countFilter++;
      if (hasValue(this.filter.Nome)) this.countFilter++;
      if (hasValue(this.filter.MotivoRecusa)) this.countFilter++;
      if (hasValue(this.filter.DataInicialRecusa)) this.countFilter++;
      if (hasValue(this.filter.DataFinalRecusa)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          Object: this.filter
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("TransferenciaRecusadaListar", data)
        .then(response => {
          this.transferenciaRecusadaLista = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar dados bancários inválidos", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Banco: null,
        Agencia: null,
        Conta: null,
        Documento: null,
        Nome: null,
        MotivoRecusa: null,
        DataInicialRecusa: null,
        DataFinalRecusa: null
      };
      this.TransferenciaRecusadaListar();
    }, AbrirModalRemover: function (e, i, view) {
      this.validatedActionForm = false;
      e.preventDefault();

      if (view == undefined && i != undefined) {
        this.pOpened = i;
        this.modalTitle = "Remoção de Dados Bancários Inválidos";
        this.BuscarTransferenciaRecusada(i);
      }
      this.$bvModal.show("mFormTransferenciaRecusada");
    },
    BuscarTransferenciaRecusada: function (id) {
      this.loadingTransferenciaRecusada = true;
      this.$store
        .dispatch("BuscarTransferenciaRecusada", { id: id })
        .then((response) => {
          this.transferenciaRecusada = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter as informações de dados bancários inválidos",
            error
          );
        })
        .finally(() => {
          this.loadingTransferenciaRecusada = false;
        });
    },
    RemoverTransferenciaRecusada: function () {
      this.loadingUpdate = true;
      this.validatedActionForm = true;

      var objetoRemover = {
        Id: this.transferenciaRecusada.Id,
        EhRemovido: true,
        MotivoRemocao: this.transferenciaRecusada.MotivoRemocao
      };

      this.$refs.ActionValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.$store
            .dispatch("RemoverTransferenciaRecusada", objetoRemover)
            .then(() => {
              this.$makeToast(
                "Removido dos registros da lista de Dados Bancários Inválidos.",
                "success",
                "Atualizado"
              );
              this.TransferenciaRecusadaListar();
              this.$bvModal.hide("mFormTransferenciaRecusada");
            })
            .catch((error) => {
              this.$makeToast(
                undefined,
                "danger",
                "Erro ao remover o registro da lista de Dados Bancários Inválidos.",
                error
              );
            })
            .finally(() => {
              this.loadingUpdate = false;
            });
        } else {
          this.loadingUpdate = false;
        }
      })
    }
  }
};
</script>

<style scoped>
.fa-red {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/transferenciaRecusada.vue